import { CustomToaster } from "../reusable-components/Toasters/toaster"
import { logout } from "../utils";

/**
 * This is the universal API call wrapper for CYGNUS DATAHUB Frontend, use this to make any API calls.
 * @param {*} type : Type of request
 * @param {*} payload : Data to be sent in the API
 * @param {*} url : API url details
 * @param {*} show_message : flag to show message
 * @param {*} customized_success_message : Message to display in toaster for successful API call
 * @param {*} customized_failure_message : Message to display in toaster for failed API call
 * @param {*} customized_error_message : Message to display in toaster for error while making an API call
 * @param {*} default_message : Use backend response message when available
 * @param {*} isblob : Flag to return JSON or BLOB response
 * @returns : JSON or BLOB response
 */
export const makeCygnusApiCall = async ({
  type = "GET",
  payload = {},
  payload_is_file = false,
  url = "",
  show_message = false,
  customized_success_message = "Successful!",
  customized_failure_message = "Failed!",
  customized_error_message = "Error occurred. Please contact support.",
  isblob = false,
  istax = false,
  rawTextResponse = false,
  path = "/tax",
  default_message = false,
  skip_success_on_condition
}) => {
  let response;
  try {
    const requestOptions = {
      method: type.toUpperCase(),
      headers: payload_is_file
        ? {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        : {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
    };

    if (type.toUpperCase() !== "GET") {
      requestOptions.body = payload_is_file ? payload : JSON.stringify(payload);
    }
    
    const uri = process.env.REACT_APP_TAX_URI;
    response = await fetch(`${uri}${path}${url}`, requestOptions);

    if (!response.ok) {
      let errorData = null;
      try {
        errorData = await response.json();
      } catch {}

      if (response.status === 401) {
        logout();
        if (show_message) {
          try {
            CustomToaster({
              type: "error",
              customized_message: "Session ended, please login back",
              api_message: "",
            });
          } catch {}
        }
        return errorData;
      }

      if (show_message) {
        try {
          CustomToaster({
            type: "error",
            customized_message:
              default_message && errorData?.message
                ? errorData.message
                : customized_failure_message,
            api_message: "",
          });
        } catch {}
      }
      return errorData;
    }

    let data;
    if (rawTextResponse) {
      data = await response.text();
    } else if (isblob) {
      data = await response.blob();
    } else {
      data = await response.json();
    }

    const shouldSkipSuccessToast =
      typeof skip_success_on_condition === "function"
        ? skip_success_on_condition(data)
        : false;

    if (rawTextResponse || isblob || data.success === true) {
      if (type !== "GET" && show_message && customized_success_message && !shouldSkipSuccessToast) {
        CustomToaster({
          type: "success",
          customized_message: customized_success_message,
          api_message: "",
        });
      }
      return data;
    } else {
      if (show_message) {
        try {
          CustomToaster({
            type: "error",
            customized_message:
              default_message && data?.message
                ? data.message
                : customized_failure_message,
            api_message: "",
          });
        } catch {}
      }
      return data;
    }
  } catch (err) {
    console.error("Err: ", err);
    if (!response && show_message) {
      CustomToaster({
        type: "error",
        customized_message: customized_error_message,
        api_message: err,
      });
    }
    return;
  }
};
